import {RequisitionTest} from '../../modules/features/requisitions/models/requisition-test';
import {TreeTest} from '../../modules/shared/models/order-entry/test';

export class TestUtils {
  public static generateTestTreeForRequisition(tests: TreeTest[]): RequisitionTest[] {
    const requisitionTests: RequisitionTest[] = [];

    tests.forEach(t => {
      const requisitionTest = new RequisitionTest();
      if (!t.parentId) {
        requisitionTest.level = 0;
      } else {
        requisitionTest.parentTestId = t.parentId;
        const parentTest = TestUtils.getId(requisitionTest.parentTestId, tests);
        if (parentTest) {
          requisitionTest.level = parentTest.parentId ? 2 : 1;
        } else {
          requisitionTest.level = 0;
        }
      }

      requisitionTest.testId = t.id;
      requisitionTests.push(requisitionTest);
    });

    return requisitionTests;
  }

  private static getId(id: number, tests: TreeTest[]) {
    return tests.find(t => t.id === id);
  }
}
